<template lang="pug">
    v-tooltip( :bottom="bottom" v-bind="tooltipProps" )
        v-btn( :color="color" :disabled="disabled" flat icon slot="activator" v-bind="buttonProps" @click="$emit( disabled ? '_' : 'click' )" ) 
            slot
        span {{ tooltip }}
</template>

<script>
    //
    export default {
        props: {

            /**
             * 
             */
            bottom: {
                type: Boolean,
                default: true,    
            },

            /**
             * 
             */
            buttonProps: {
                type: Object,
                default: () => ({}),
            },
            
            /**
             * 
             */
            color: {
                type: String,
                default: "primary",
            },
            
            /**
             * 
             */
            disabled: {
                type: Boolean,
                default: false,
            },
            
            /**
             * 
             */
            tooltipProps: {
                type: Object,
                default: () => ({}),
            },

            /**
             * 
             */
            tooltip: {
                type: String,
                default: "",
            },
        },
    }
</script>